/* sugar:assets/product-buy-button.js@2.1.7 */
/*
 * product-buy-button — keeps the price inside the button label in step.
 *
 * Only runs when the label carries a [price] / [compare_price] / [price_per:N] / [unit_price] token or
 * the button links to a page; the label arrives already filled from Liquid, so the first paint is
 * correct before this file loads. The arithmetic is sugar-pricing.js, the same store the price
 * block and the subtotal read.
 */
(function () {
  /*
   * A button in a sticky bar with no tiers of its own speaks for the page's product section,
   * the way product-form.js sends that section's tier when the bar's button is clicked.
   */
  function pricingSectionId(root, config) {
    if (!root.closest('sticky-custom, sticky-product')) return config.sectionId;
    const own = root.closest('.shopify-section');
    if (own && own.querySelector('.offer, [data-bundle-builder]')) return config.sectionId;
    const main = Array.prototype.find.call(
      document.querySelectorAll('product-info[data-section][data-product-id="' + config.productId + '"]'),
      (el) => !own || !own.contains(el)
    );
    return main ? main.dataset.section : config.sectionId;
  }

  /* The same rounding the Gift Unlocks badge prints its prices with. */
  function roundCents(cents, rounding) {
    if (!rounding || rounding === 'none') return cents;
    const dollars = Math.floor(cents / 100);
    if (rounding === '95') return dollars * 100 + 95;
    if (rounding === '99') return dollars * 100 + 99;
    if (rounding === '00') return dollars * 100;
    return cents;
  }

  /*
   * What the section's Gift Unlocks hand out at this quantity, each gift at the price its badge
   * shows. A gift listed twice (a desktop and a phone copy of the block) counts once.
   */
  function giftValue(sectionEl, quantity) {
    if (!sectionEl) return 0;
    const seen = new Set();
    let total = 0;
    sectionEl.querySelectorAll('[data-gift-unlocks]').forEach((gifts) => {
      let cfg = {};
      try {
        cfg = JSON.parse(gifts.dataset.giftUnlocksConfig || '{}');
      } catch (e) {
        /* priced without rounding */
      }
      gifts.querySelectorAll('[data-gift-unlock]').forEach((item) => {
        const unlocked =
          item.dataset.unlockMode === 'variant'
            ? item.dataset.unlocked === 'true'
            : quantity >= Math.max(1, parseInt(item.dataset.requiredQuantity, 10) || 1);
        const key = item.dataset.variantId;
        if (!unlocked || !key || seen.has(key)) return;
        seen.add(key);
        total += roundCents(parseInt(item.dataset.giftPrice, 10) || 0, cfg.rounding);
      });
    });
    return total;
  }

  /* The page the button opens, carrying the chosen count the way a Bundle Builder reads it. */
  function linkFor(base, quantity) {
    try {
      const url = new URL(base, window.location.href);
      url.searchParams.set('bundle', String(quantity));
      return url.origin === window.location.origin ? url.pathname + url.search + url.hash : url.href;
    } catch (e) {
      return base;
    }
  }

  function mount(island) {
    if (island.dataset.mounted) return;
    island.dataset.mounted = 'true';

    let config;
    try {
      config = JSON.parse(island.textContent);
    } catch (e) {
      return;
    }

    const root = document.querySelector('[data-_sf="' + config.blockId + '"]');
    if (!root || !window.SugarPricing) return;

    if (!root.querySelector('[data-buy-button-current-price], [data-buy-button-compare-price], [data-buy-button-per], [data-buy-button-link]')) return;

    const sectionId = pricingSectionId(root, config);
    const store = window.SugarPricing.store(
      sectionId === config.sectionId ? config : Object.assign({}, config, { sectionId: sectionId })
    );

    let stop;
    stop = store.subscribe(function (state) {
      /* A re-rendered section leaves this copy detached; the fresh island has taken over. */
      if (!root.isConnected) {
        if (stop) stop();
        return;
      }
      /* Looked up on every update: a variant change lets product-info swap the label's HTML
         for the server's copy, and the spans captured at mount would be detached by then. */
      const currentEls = root.querySelectorAll('[data-buy-button-current-price]');
      const compareEls = root.querySelectorAll('[data-buy-button-compare-price]');
      const perEls = root.querySelectorAll('[data-buy-button-per]');
      const links = root.querySelectorAll('[data-buy-button-link]');
      const money = (cents) => window.SugarPricing.formatMoney(cents, config.format, !!config.hideCents && cents % 100 === 0);
      const gifts = config.countGifts && compareEls.length ? giftValue(store.sectionEl, state.quantity) : 0;
      const compare = gifts ? Math.max(state.totalCompare, state.totalPrice) + gifts : state.totalCompare;
      const onSale = gifts ? compare > state.totalPrice : state.onSale;
      currentEls.forEach((el) => {
        el.textContent = money(state.totalPrice);
      });
      compareEls.forEach((el) => {
        el.hidden = !onSale;
        if (onSale) el.textContent = money(compare);
      });
      perEls.forEach((el) => {
        const text = window.SugarPricing.fillPerTokens(el.dataset.buyButtonPer, state, config.format, !!config.hideCents);
        if (el.textContent !== text) el.textContent = text;
      });
      links.forEach((el) => {
        const href = linkFor(el.dataset.buyButtonLink, state.quantity);
        if (el.getAttribute('href') !== href) el.setAttribute('href', href);
      });
    });
  }

  function init() {
    document.querySelectorAll('script[data-sugar-buy-button]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
